// extracted by mini-css-extract-plugin
module.exports = {"Auth":"Auth_Auth__17frN","AuthForm":"Auth_AuthForm__3XWke"};